var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnEns = function SvgIcnEns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.876 8.267s-.338-.559-.475-.843c-.135-.284-.492-1.246.027-2.262.096-.187.245-.362.543-.579L7.782 2 3.876 8.267Z",
    fill: "#292525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.685 12.233c-.907-.635-1.55-1.742-1.651-2.972-.055-.8-.034-1.188-.002-1.514.048-.463.247-.948.442-1.372 0 0 .102-.209.158-.31-.032.193-.033.39-.005.583.07.426.217.837.434 1.214C5.221 11.422 7.778 15 7.778 15l-4.093-2.767ZM12.598 9.576a14.776 14.776 0 0 0-.475-.843L8.216 15l3.813-2.583c.297-.216.446-.392.542-.579.52-1.016.162-1.978.027-2.262Z",
    fill: "#292525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.315 4.767c.907.635 1.55 1.742 1.652 2.972.054.8.032 1.188.001 1.514-.048.463-.247.948-.442 1.373 0 0-.102.208-.158.309.032-.193.034-.39.005-.583a3.562 3.562 0 0 0-.434-1.213C10.779 5.579 8.223 2 8.223 2l4.092 2.767Z",
    fill: "#292525"
  })));
};
export default SvgIcnEns;